import { render } from "./GroupClass.vue?vue&type=template&id=f7fcec44&scoped=true&ts=true"
import script from "./GroupClass.vue?vue&type=script&lang=ts"
export * from "./GroupClass.vue?vue&type=script&lang=ts"

import "./GroupClass.vue?vue&type=style&index=0&id=f7fcec44&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7fcec44"]])

export default __exports__